import * as authApi from '@/api/auth';

const login = {
    namespaced: true,
    // 초기값은 빈 상태. 영속화/복원은 vuex-persistedstate 가 처리.
    state: () => ({
        token: null,
        nickname: '',
    }),
    mutations: {
        setUser(state, payload) {
            state.token = payload.token;
            state.nickname = payload.nickname;
        }
    },
    actions: {
        async requestLogin(context, args) {
            await authApi.login(args)
        },
        async requestLogout(context, args) {
            await authApi.logout(args)
        }
    },
    getters: {
        getToken(state) {
            return state.token
        },
        getName(state) {
            return state.nickname
        },
        isAuthenticated(state) {
            console.info("isAuthenticated: " + !!state.token)
            return !!state.token;
        }
    }
}
export default login